import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';
import { CiInboxOut } from 'react-icons/ci';
import { TbCashOff } from 'react-icons/tb';
import { FaSearch } from 'react-icons/fa';
import ActionButton from '../../components/ActionButton';

const AddRemboursement = ({ isVisible = true, onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState([]);
   
    
    
    const [remboursement, setRemboursement] = useState({
        montant: 0,
        matricule:'',
        eleve:'',
        classe:'',
        eleveId:''
        
    });

    const [req, setReq] = useState({
        matricule:'',
        
    });

   
    const navigate = useNavigate();
    
    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.post('/remboursement/save', remboursement)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    const getEtudiant = () => {
        
        axiosClient.get('/inscription/matricule?matricule=' + req.matricule)
            .then(response => {
                setRemboursement({...remboursement,
                    eleveId:response.data.inscription.id,
                    eleve:response.data.inscription.eleve,
                    classe:response.data.inscription.classe.libelle});
                
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    
    if (!isVisible) {
        return null
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className=''>
                            <Header icon={<TbCashOff />} title="Ajouter une remboursement" titleAr={"أضف استرداد"} />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                        
                            <>
                                <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-3'>
                                    <div className='flex-col w-full justify-evenly '>
                                        <div className='mr-2 flex gap-2'>
                                            <Input label="Matricule" labelAr={"رقم التسجيل"} type="number" value={req.matricule}  onChange={ev => setReq({ ...req, matricule: ev.target.value })} required="required" />
                                            <div className="mt-6">
                                                <ActionButton className="mt-6" onClick={()=>{getEtudiant()}} color="bg-blue-500" icon={<FaSearch />} textColor="text-white" title="Chercher" />
                                            </div>
                                        </div>
                                        <div className='flex gap-2 mr-2 '>
                                            <Input label="Eleve" labelAr={"الطالب"} type="text" value={remboursement.eleve}  onChange={ev => setRemboursement({ ...remboursement, eleve: ev.target.value })} required="required" />
                                            <Input label="Classe" labelAr={"الطالب"} type="text" value={remboursement.classe}  onChange={ev => setRemboursement({ ...remboursement, classe: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Montant" labelAr={"لمبلغ"} type="number" value={remboursement.montant}  onChange={ev => setRemboursement({ ...remboursement, montant: ev.target.value })} required="required" />
                                        </div>
                                        
                                    </div>
                                </div>
                            </>
                        
                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                {loading ? <Loading /> :
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />

                                }
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddRemboursement